import React from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';
import ContactUs from '../../../pages/ContactUs/ContactUs';
import SubscribeForm from '../Forms/SubscribeForm';

function Footer() {
  return (
    <footer className='footer'>
      {/* Main Footer Content */}
      <div className='footer-content'>
        {/* Left Section - Logo and About */}
        <div className='footer-section left-section'>
          <div className='footer-logo'>
            <Link to="/">
              <img
                src="../images/fomeje-logo-2025.png"
                alt="FOMEJE Logo"
                className="logo-image"
              />
            </Link>
          </div>
          <p className='about-text'>
            Empowering Mediterranean youth through dialogue, collaboration, and cultural exchange.
          </p>
        </div>

        {/* Middle Section - Stay Connected */}
        <div className='footer-section middle-section'>
          <h4>Stay Connected</h4>
          <p>Subscribe to our newsletter</p>
          <SubscribeForm />
          <ContactUs />
        </div>

        {/* Right Section - Legal */}
        <div className='footer-section right-section'>
          <h4>Legal</h4>
          <ul>
            <li><a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a></li>
            <li><a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer">Terms of Service</a></li>
            <li><a href="https://policies.google.com/technologies/cookies" target="_blank" rel="noopener noreferrer">Cookie Policy</a></li>
          </ul>
        </div>
      </div>
    </footer>
  );
}

export default Footer;